import * as React from "react";

import * as Sentry from "@sentry/browser";

export default class ErrorBoundary extends React.Component<
  { children: React.ReactNode },
  object
> {
  componentDidCatch(error: any, info: any) {
    if (
      process.env.NEXT_PUBLIC_ENVIRONMENT === "local" ||
      process.env.NEXT_PUBLIC_ENVIRONMENT === "development"
    ) {
      console.error(error, info);
    } else {
      Sentry.captureException(error);
    }
  }

  render() {
    return this.props.children;
  }
}
